import { logger } from '@getvim/vim-connect-logger';
import { useEffect, useMemo } from 'react';
export const useEnrichLoggerMetadata = ({
  user,
  organization,
  ehrType,
  sessionId: userSessionId,
}): void => {
  const log = useMemo(() => logger.scope('Privia App Client [useEnrichLoggerMetadata]'), []);

  useEffect(() => {
    try {
      log.info('Setting logger metadata', {
        noPHI: true,
        ehrUserName: user?.identifiers?.ehrUsername,
        organizationId: organization?.identifiers?.id,
        userSessionId,
        ehrType,
      });
      logger.setMetadata({
        deviceId: '',
        adapterName: ehrType,
        organizationId: organization?.identifiers?.id,
        organization_name: organization?.identifiers?.name,
        version: window?.$vim_environment?.version || '',
        windowId: '',
        ehrUserName: user?.identifiers?.ehrUsername,
      });
      logger.setUserMetadata({ userSessionId });
    } catch (error) {
      log.warning('Error setting logger metadata', { error: error, noPHI: true });
    }
  }, [log, ehrType, organization, user, userSessionId]);
};
